export default function SecondarySidebar({ menuItems, setActiveTab, activeTab }) {

  const getDotColor = (state) => {
    switch (state) {
      case 'verify': return 'bg-yellow-400';
      case 'done': return 'bg-green-500';
      case 'cancel': return 'bg-red-400';
      default: return 'bg-gray-300'; // Pas de bulletin
    }
  };

  return (
    <div className="row-span-5 bg-white rounded-lg h-screen">
      <ul className="py-5 space-y-4">
        {menuItems.map((item) => (
          <li
            key={item.id}
            className={`px-4 py-4 flex justify-between gap-2 items-center cursor-pointer hover:bg-[--bg-color] ${
              activeTab === item.id 
                ? "font-semibold border-l-4 bg-gray-50 border-orange-400" 
                : ""
            }`}
            onClick={() => setActiveTab(item.id)}
          >
            <div className="flex items-center">
              {item.icon && <span className="mr-2">{item.icon}</span>}
              {item.label}
            </div>
            {item.payslipState && <span className={`w-2 h-2 rounded-full ${getDotColor(item.payslipState)}`}></span> }
          </li>
        ))}
      </ul>
    </div>
  );
}
